/* tslint:disable */
/* eslint-disable */
export enum LogType {
  Debug = 'DEBUG',
  Info = 'INFO',
  Warn = 'WARN',
  Error = 'ERROR'
}
